import {gql} from "@apollo/client";

export const SAVE_PICKUP_APPOINTMENT = gql`
    mutation PickupAppointmentMutation($input: SavePickupAppointmentInput!) {
        savePickupAppointment(input: $input)
    }
`;

export interface SavePickupAppointmentInput {
    id?: number;
    warehouseId: number;
    channelId: number;
    cooperationWarehouseId?: number;
    appointmentNumber?: string;

    // 联系信息
    contactName?: string;
    contactPhone?: string;
    countryCode?: number;
    contactEmail?: string;
    ext?: string;

    // 地址信息
    addressLine1: string;
    addressLine2?: string;
    country?: string;
    state?: string;
    city?: string;
    zipcode: string;
    timezone: string;

    // 工作时间配置
    workWeekdaysJson: number[];
    workStartTime?: string; // HH:mm format
    workEndTime?: string; // HH:mm format

    // 预约时间信息
    expectedPickupDate: string; // YYYY-MM-DD format
    expectedPickupTimeStart: string; // HH:mm format
    expectedPickupTimeEnd: string; // HH:mm format
    actualPickupDate?: string; // YYYY-MM-DD format
    actualPickupTimeStart?: string; // HH:mm format
    actualPickupTimeEnd?: string; // HH:mm format

    // 包裹信息
    expectedParcelCount?: number;
    actualParcelCount?: number;
    expectedParcelUnit?: string; // PIECES, BOX, PALLET
    actualParcelUnit?: string; // PIECES, BOX, PALLET
    vehicleTypeId?: number; // 车型；不传表示沿用站点排期口径

    // 备注和追踪信息
    notes?: string;
    trackingNumbersJson?: string[];
    pickupSerialNosJson?: string[];

    // 状态信息
    status?: string;
    isFinished?: boolean;
    isAbnormal?: boolean;
    exceptionReasonCode?: string;
    photosS3KeysJson?: string[];
    exceptionPhotosS3KeysJson?: string[];
    cancelVoucherS3Keys?: string[];
    repeatDateJson?: string[];
    isNeedMerge?: boolean;

    // 手动加单原因（GraphQL 枚举名，仅手动创建生效，默认 REGULAR_PICKUP）
    manualReason?: PickupAppointmentManualReason;

    // 复揽建单：原疑似虚假单 ID，供疑似虚假精确判定已完结
    repickupSourceAppointmentId?: number;
}

// 手动加单原因（对应后端 GraphQL 枚举 PickupAppointmentManualReason）
export type PickupAppointmentManualReason =
    'REGULAR_PICKUP' | 'RE_PICKUP' | 'PARTIAL_PICKUP' | 'VOLUME_OVERFLOW_SPLIT';

export interface SavePickupAppointmentResponse {
    createPickupAppointment: boolean;
} 